import React from 'react';
import gugo from '../../../assets/gugo.svg';
import bet from '../../../assets/bet.svg';
import Telegram from '../../../assets/telegram.png';
import Whatsapp from '../../../assets/icon-whatsapp.9fe2ae9.svg';
import Instagram from '../../../assets/instagram.png';
import Facebook from '../../../assets/fb.png';
import Twitter from '../../../assets/twitter.png';
import SocialNetwork from '../../../assets/SocialNetworks.1959771.png';
import AppDownload from '../../../assets/downloadicon.png';
import AppleLogo from '../../../assets/applelogo.png';
import AndroidLogo from '../../../assets/andriodlogo.png';

const socialApp = [
    {
        id: 1,
        class: 'telegram',
        icon: (<img width={25} height={40} className='m-auto max-sm:h-[18px] max-sm:w-[18px]' src={Telegram} />)
    },
    {
        id: 2,
        class: 'whatsapp',
        icon: (<img width={25} height={40} className='m-auto max-sm:h-[18px] max-sm:w-[18px]' src={Whatsapp} />)
    },
    {
        id: 3,
        class: 'instagram',
        icon: (<img width={25} height={40} className='m-auto max-sm:h-[18px] max-sm:w-[18px]' src={Instagram} />)
    },
    {
        id: 4,
        class: 'facebook',
        icon: (<img width={25} height={40} className='m-auto max-sm:h-[18px] max-sm:w-[18px]' src={Facebook} />)
    },
    {
        id: 5,
        class: 'twitter',
        icon: (<img width={45} height={40} className='m-auto' src={Twitter} />)
    },
]

const LobbyFooter = () => {
    return (
        <>
            <div className='flex mt-6'>
                <img src={gugo} width={40} alt="" />
                <img src={bet} width={29} alt="" />
                <div className='m-[7px] h-[1px] bg-gradient-to-r from-[#0b195e] to-[#185fc9] w-full'></div>
            </div>
            <div className='social-app-download flex flex-col md:flex-row w-full mt-4 gap-4'>
                <div className='md:w-2/4 order-3 md:order-1'>
                    <div className='flex items-center'>
                        <img src={SocialNetwork} className='h-[21px] me-3' alt="" />
                        <span className='text-lg font-bold bg-gradient-to-t from-[#009ae5] to-[#46c2ff] bg-clip-text text-transparent'>Social Networks</span>
                    </div>
                    <div className='grid grid-cols-5 mt-2 gap-[14px] h-[34px] md:h-12'>
                        {socialApp.map(item => (<div className={`${item.class} rounded-[10px] content-center cursor-pointer hover:scale-105 hover:ease-in-out duration-500`} key={item.id}>
                            {item.icon}
                        </div>))}
                    </div>
                </div>
                <div className='divider md:hidden bg-[#66a1ff33] h-[1px] w-full order-2'></div>
                <div className='md:w-2/4 order-1 md:order-2'>
                    <div className='flex items-center'>
                        <img src={AppDownload} className='h-[21px] me-3' alt="" />
                        <span className='text-lg font-bold bg-gradient-to-t from-[#009ae5] to-[#46c2ff] bg-clip-text text-transparent'>App Download</span>
                    </div>
                    <div className='grid grid-cols-2 mt-2 gap-[14px] h-12'>
                        <div className={`rounded-[10px] justify-center items-center flex apple hover:scale-105 hover:ease-in-out duration-500 cursor-pointer`}>
                            <img src={AppleLogo} className='h-[28px]' alt="" />
                            <div className='ps-[9px]'>
                                <p className='leading-none text-xs font-semibold'>Download for</p>
                                <p className='font-bold p-0 text-[17px] leading-none'>iOS App</p>
                            </div>
                        </div>
                        <div className={`rounded-[10px] justify-center items-center flex android hover:scale-105 hover:ease-in-out duration-500 cursor-pointer`}>
                            <img src={AndroidLogo} className='h-[28px]' alt="" />
                            <div className='ps-[9px]'>
                                <p className='leading-none text-xs font-semibold'>Download for</p>
                                <p className='font-bold p-0 text-[17px] leading-none'>Android</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LobbyFooter